import styled from 'styled-components';
import { breakpoints } from '../../styles/breakpoints';
import { ellipsis } from '../../styles/ellipsis';

const PlaybackStartingSubtitle = styled.div`
	font-size: 24px;
	max-width: 100%;
	color: #aaa;
	font-weight: 300;
	line-height: 1.2;
	${ellipsis};

	@media ${breakpoints.sm} {
		font-size: 36px;
	}

	@media ${breakpoints.md} {
		font-size: 46px;
		max-width: 80%;
	}
`;

export default PlaybackStartingSubtitle;
